<template>
  <div class="flex flex-col w-full min-h-screen">
    <Menu />
    <Profile />
    <Posts />
    <Connections v-if="hasConnections" />
    <Footer />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import Menu from './Menu.vue'
import Profile from './Profile.vue'
import Posts from './Posts.vue'
import Connections from './Connections.vue'
import Footer from './Footer.vue'
import { useStore } from '../../../js/store/index.js'

export default defineComponent({
  name: 'Home',
  components: { Menu, Profile, Posts, Connections, Footer },

  setup() {
    const store = useStore()

    const hasConnections = computed(
      () => store.getters['contributors/hasProfileConnections'],
    )

    return { hasConnections }
  },
})
</script>
